module.exports = __webpack_public_path__ + "img/cgpclothing.f8d798e1.jpg";